export default {
  free: 'GRÁTIS',
  save: 'Poupe {{amount}}',
};
